/**
 * ModuleBadge - Zeigt Modul-Reifegrad an
 *
 * PR-5X-D: Modul-System live - Context-basiert
 *
 * Rendert Badge basierend auf Modul-ID.
 * Bei STABLE-Modulen wird nichts gerendert.
 *
 * Nutzt useModules Context für Live-Daten vom API.
 */

import { useModules, MATURITY_STYLES, MATURITY_LABELS } from '../hooks/useModules';
import { Tooltip } from './Tooltip';

interface ModuleBadgeProps {
  module: string;
  className?: string;
}

/**
 * ModuleBadge Komponente
 *
 * Nutzt useModules Context - muss innerhalb ModulesProvider sein.
 */
export function ModuleBadge({ module, className = '' }: ModuleBadgeProps) {
  const { getModule, loading } = useModules();

  // Waehrend Loading: nichts rendern (graceful)
  if (loading) {
    return null;
  }

  const moduleData = getModule(module);

  // Nicht gefunden oder STABLE: nichts rendern
  if (!moduleData || moduleData.maturity === 'STABLE') {
    return null;
  }

  const label = MATURITY_LABELS[moduleData.maturity];
  const styles = MATURITY_STYLES[moduleData.maturity];

  return (
    <Tooltip content={moduleData.tooltip} className={className}>
      <span
        className={`
          inline-flex items-center px-1.5 py-0.5 text-xs font-medium 
          border rounded
          ${styles}
        `}
        role="status"
        aria-label={`${label}: ${moduleData.tooltip}`}
      >
        {label}
      </span>
    </Tooltip>
  );
}
